import enMessages from "../locales/tr_TR.json";
import trTR from "antd/lib/locale/tr_TR";

const TrLang = {
  messages: {
    ...enMessages,
  },
  antLocale: trTR,
  locale: "tr-TR",
};
export default TrLang;
